export enum GiftPlanType {
  GROCERY_YEARLY = 'GROCERY_YEARLY',
  GROCERY_SIX_MONTHS = 'GROCERY_SIX_MONTHS',
}
